import { render, staticRenderFns } from "./ConsumedChartAskue.vue?vue&type=template&id=9a04e25a&"
import script from "./ConsumedChartAskue.vue?vue&type=script&lang=ts&"
export * from "./ConsumedChartAskue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports